const AUTH_ERROR_MESSAGES: Record<string, string> = {
  'auth/invalid-email': "That email address doesn't look right.",
  'auth/missing-email': 'Enter your email address.',
  'auth/missing-password': 'Enter your password.',
  // With email-enumeration protection on, Firebase collapses an unknown account
  // and a wrong password into this one code.
  'auth/invalid-credential': 'Wrong email or password.',
  'auth/wrong-password': 'Wrong email or password.',
  'auth/user-not-found': 'Wrong email or password.',
  'auth/user-disabled': 'This account has been disabled.',
  'auth/email-already-in-use': 'That email already has an account — sign in instead.',
  'auth/account-exists-with-different-credential':
    'That email already has an account created with a different sign-in method.',
  'auth/weak-password': 'Choose a password with at least 6 characters.',
  'auth/too-many-requests': 'Too many attempts. Try again in a few minutes.',
  'auth/network-request-failed': 'Network error. Check your connection and try again.',
  'auth/invalid-action-code': 'This sign-in link has expired or was already used. Request a new one.',
  'auth/expired-action-code': 'This sign-in link has expired. Request a new one.',
  'auth/operation-not-allowed': 'Email sign-in is not enabled for this app.',
}

/** Turns a Firebase auth error into something worth showing a person. */
export function authErrorMessage(error: unknown): string {
  const code = (error as { code?: string } | null)?.code
  return (
    (code && AUTH_ERROR_MESSAGES[code]) ||
    (error as Error | null)?.message ||
    'Something went wrong. Try again in a moment.'
  )
}
